import React from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import type { NavigationItem } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { ItemType } from '../../../common/model/index.tsx';
import AddLinkModal from './add-link-modal/index.tsx';
import AddRepositoryModal from './add-repository-modal/index.tsx';
import SelectItemTypeModal from './select-item-type-modal/index.tsx';
import AddItem from './view.tsx';

type Props = {
	addItem:
		| {
				type: ItemType | undefined;
		  }
		| undefined;
	baseUrl: string;
	projectKey: string;
	onAddItemCompleted: (arg1: { item: NavigationItem | undefined }) => void;
	onAddLink: () => void;
	onAddRepo: () => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	if (!props.addItem) {
		return null;
	}

	return (
		<ModalTransition>
			{props.addItem && (
				<AddItem
					itemType={props.addItem.type}
					SelectItemTypeModal={SelectItemTypeModal}
					AddLinkModal={AddLinkModal}
					AddRepositoryModal={AddRepositoryModal}
					baseUrl={props.baseUrl}
					projectKey={props.projectKey}
					onAddItemCompleted={props.onAddItemCompleted}
					onAddLink={props.onAddLink}
					onAddRepo={props.onAddRepo}
				/>
			)}
		</ModalTransition>
	);
};
